import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { AvatarItem } from '@atlaskit/avatar';
import { css, jsx } from '@emotion/react';
import { components } from '@atlaskit/select';
import { SizeableAvatar } from './SizeableAvatar';
import { getAvatarUrl } from './utils';
const avatarItemComponent = css({
  border: 'none !important',
  padding: `${"var(--ds-space-0, 0px)"} !important`,
  width: 'auto',
  overflow: 'hidden',
  minWidth: '100px',
  '& > span': {
    boxSizing: 'border-box'
  },
  '&:hover': {
    width: 'auto',
    padding: 0,
    border: 'none'
  }
});
export const SingleValue = props => {
  const {
    data: {
      label,
      data
    },
    selectProps: {
      appearance,
      isFocused
    }
  } = props;
  return !isFocused ? jsx(components.SingleValue, props, jsx(AvatarItem, {
    backgroundColor: "transparent",
    avatar: jsx(SizeableAvatar, {
      src: getAvatarUrl(data),
      appearance: appearance
    }),
    primaryText: label
  }, ({
    ref,
    ...props
  }) => jsx("div", _extends({
    css: avatarItemComponent
  }, props)))) : null;
};